<template>
  <ion-page>
    <ion-content class="bg-gs">
      <swiper :modules="modules" :autoplay="false" :pagination="true">
        <swiper-slide>
          <div class="slide">
            <div align="center">
              <h1 class="h1-onboarding1">Pre-order coffee, Anywhere...</h1>
              <img src="assets/images/welcome1.png" class="welcome1" />
            </div>
            <nextButton id="next-button1" />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide">
            <img src="assets/images/welcome2.png" class="welcome2" />
            <div align="center">
              <h1 class="h1-onboarding2">One App, Your Coffee</h1>
            </div>
            <nextButton />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="slide">
            <img src="assets/images/welcome3.png" class="welcome3" />
            <div align="center">
              <h1 class="h1-onboarding3">
                Order ahead <br />and skip the queue...
              </h1>
            </div>
            <button class="btn-onboarding" @click="completeOnboarding">
              Get started
            </button>
          </div>
        </swiper-slide>
      </swiper>
    </ion-content>
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/vue";
import { IonPage, IonContent, IonButton } from "@ionic/vue";
import nextButton from "@/components/nextButton.vue";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "@ionic/vue/css/ionic-swiper.css";

export default defineComponent({
  components: {
    Swiper,
    SwiperSlide,
    IonContent,
    IonButton,
    Navigation,
    nextButton,
    IonPage,
  },
  setup() {
    const swiper = useSwiper();
    const router = useRouter();

    const completeOnboarding = () => {
      localStorage.setItem("hasSeenOnboarding", "true");
      router.replace("/welcome");
    };

    return {
      swiper,
      modules: [Autoplay, Pagination, Navigation],
      completeOnboarding,
    };
  },
});
</script>
<style scoped>
.bg-gs {
  --background: #f87e63;
}
.swiper {
  height: 100%;
}
.swiper-slide {
  display: block;
  background-color: #f87e63;
  height: 100%;
}
.swiper .swiper-slide img {
  width: auto;
  height: auto;
}
.swiper-slide img {
  margin-top: 0%;
  margin-bottom: 0%;
  pointer-events: none;
}
.swiper .swiper-slide {
  padding: 0px 0px 0px 0px !important;
}
.h1-onboarding1 {
  width: 100%;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  color: #fff;
  margin-bottom: 20%;
  margin-top: 20%;
}
.h1-onboarding2 {
  width: 70%;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  color: #fff;
  margin-top: 5%;
  margin-bottom: 5%;
}
.h1-onboarding3 {
  width: 70%;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  text-align: center;
  color: #fff;
  margin-top: 15%;
  margin-bottom: 10%;
}
.p-onboarding {
  width: 75%;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  text-align: center;
  color: #828282;
}
.btn-onboarding {
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  background-color: #f76a4b;
  font-family: "Gilroy";
  margin-top: 10%;
  margin-bottom: 10%;
  text-transform: none;
  letter-spacing: 1px;
  height: 45px;
  width: auto;
  margin: auto;
  padding: 0 5% 0 5%;
  border-radius: 120px !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
ion-button {
  margin: 0px 30px 0px 30px;
  --border-radius: 4px;
}
@media only screen and (max-height: 800px) {
  .swiper .swiper-slide img {
    width: auto;
    height: 320px;
  }
}
.swiper-horizontal > .swiper-pagination-bullets,
.swiper-pagination-bullets.swiper-pagination-horizontal,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: -20px;
  left: 0;
  width: 100%;
}
.welcome1 {
  transform: scale(2);
  margin-top: 40% !important;
}
.welcome2 {
  margin-top: 10% !important;
}
#next-button1 {
  margin-top: 4% !important;
}
/* CSS for iPhone SE (1st and 2nd generation) */
@media only screen and (max-width: 320px) and (max-height: 568px) and (-webkit-device-pixel-ratio: 2) {
  .h1-onboarding1 {
    width: 100%;
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
    text-align: center;
    color: #fff;
    margin-bottom: 20%;
    margin-top: 6%;
  }
  #next-button1 {
    margin-top: 0% !important;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .swiper-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-bullets.swiper-pagination-horizontal,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 170px;
    left: 0;
    width: 100%;
    display: hidden;
  }
  .h1-onboarding1 {
    width: 100%;
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 600;
    font-size: 34px;
    line-height: 120%;
    text-align: center;
    color: #fff;
    margin-bottom: 5%;
    margin-top: 6%;
  }
  .welcome1 {
    transform: scale(1.5) !important;
    margin-top: 20% !important;
  }
  #next-button1 {
    margin-top: -10% !important;
  }
  .welcome2 {
    transform: scale(1.5);
    margin-top: 10% !important;
  }
  .welcome3 {
    transform: scale(1.8);
    margin-top: 0% !important;
  }
  .h1-onboarding3 {
    width: 70%;
    font-family: "Gilroy";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 120%;
    text-align: center;
    color: #fff;
    margin-top: 32%;
    margin-bottom: 5%;
  }
}
/* CSS specifically for Retina iPad Pro (11-inch and 12.9-inch) */
@media only screen and (min-width: 834px) and (max-width: 1366px) and (-webkit-device-pixel-ratio: 2) {
  .welcome1 {
    transform: scale(1) !important;
    margin-top: 15% !important;
  }
  .welcome2 {
    transform: scale(1.5);
    margin-top: 10% !important;
  }
}
</style>
